<template>
  <v-card>
    <v-card-text>
      <h2>Checkout Cancelled</h2>
      <p class="mt-3 mb-10">
        Your checkout has been cancelled and no order has been placed.
      </p>
      <v-btn color="info" @click="backToDashboard()">Go back to dashboard</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "GiftCardsCancelled",
  metaInfo: {
    title: "Gift Cards Order Cancelled"
  },
  methods: {
    backToDashboard() {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>
